const version_check_modal = {
  title: 'New Update Available!',
  description:
    "We've made improvements and added new features to enhance your experience. Update to enjoy the full app!",
  cta: 'Update Now',
}

export default version_check_modal
